import { Request } from '../../Servidor/Request';

export class RuralPropertySituationRequest {
    private sgepsituacaoproprural: number;
    private nome: string;

	constructor(sgepsituacaoproprural: number, nome: string) {
		this.sgepsituacaoproprural = sgepsituacaoproprural;
		this.nome = nome;
	}


    /**
     * Getter sgepsituacaoproprural
     * @return {number}
     */
	public getSgepsituacaoproprural(): number {
		return this.sgepsituacaoproprural;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class RuralPropertySituationResponse {
    private success: boolean;

	constructor(success: boolean) {
        this.success = success
    }
    

    /**
     * Getter success
     * @return {boolean}
     */
	public getSuccess(): boolean {
		return this.success;
	}
}

export class RuralPropertySituationStructRequest {
    private sgepsituacaoproprural: number;

	constructor(sgepsituacaoproprural: number) {
        this.sgepsituacaoproprural = sgepsituacaoproprural;
	}


    /**
     * Getter sgepsituacaoproprural
     * @return {number}
     */
	public getSgepsituacaoproprural(): number {
		return this.sgepsituacaoproprural;
	}

}

export class RuralPropertySituationStructResponse {
    private sgepsituacaoproprural: number;
    private nome: string;

	constructor(sgepsituacaoproprural: number, nome: string) {
		this.sgepsituacaoproprural = sgepsituacaoproprural;
		this.nome = nome;
	}


    /**
     * Getter sgepsituacaoproprural
     * @return {number}
     */
	public getSgepsituacaoproprural(): number {
		return this.sgepsituacaoproprural;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class RuralPropertySituationInteractor {
    public fetchSave(request: RuralPropertySituationRequest): PromiseLike<RuralPropertySituationResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/situacao-propriedade-rural/salvar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = new RuralPropertySituationResponse(rs.Status == "Sucesso")
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: RuralPropertySituationStructRequest): PromiseLike<RuralPropertySituationStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/situacao-propriedade-rural/buscar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}